import { Talent } from "../../Classes";

const tier6 = [
  null,
  null,
  new Talent(
    "Fire power",
    "spell_fire_immolation",
    ["Increases the damage fone by your Fire spells by ", "%."],
    5,
    [[2, 4, 6, 8, 10]],
  ),
  null,
];

export default tier6;
